var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkArcana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.521858 31.0469L29.9755 31.0139C38.693 31.0045 45.7519 24.1818 45.7422 15.7761C45.7324 7.36927 38.6564 0.561876 29.9401 0.572468L0.486472 0.605419L0.523079 31.0469L0.521858 31.0469Z",
    fill: "url(#paint0_linear_18688_63939)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.523083 30.5769L29.9768 30.544C38.693 30.5346 45.7519 23.7131 45.7422 15.3062C45.7324 6.90053 38.6564 0.0943006 29.9402 0.103716L0.486472 0.136667L0.523083 30.5781L0.523083 30.5769Z",
    fill: "url(#paint1_linear_18688_63939)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2342 15.3095C44.244 23.2044 36.8112 29.634 28.6246 29.6434L0.521896 29.674L0.521896 30.0859L28.6246 30.0542C37.0467 30.0447 44.6699 23.4304 44.6601 15.3083C44.6504 7.18747 37.0113 0.588386 28.5892 0.5978L0.485289 0.629576L0.485289 1.04033L28.5892 1.00973C36.7758 1.00031 44.2245 7.41579 44.233 15.3107L44.2342 15.3095Z",
    fill: "url(#paint2_linear_18688_63939)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0657 26.7988C34.6987 26.7918 40.0686 21.5991 40.0625 15.2025C40.054 8.80582 34.6707 3.62612 28.0389 3.63319C21.4059 3.64142 16.0348 8.83171 16.0421 15.2295C16.0495 21.6262 21.4327 26.8059 28.067 26.7988L28.0657 26.7988Z",
    fill: "url(#paint3_linear_18688_63939)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.298 12.6444C15.7198 18.289 19.1853 24.0986 25.0384 25.6205C30.8915 27.1425 36.9158 23.8005 38.494 18.1559C40.0722 12.5114 36.6067 6.70175 30.7536 5.17979C24.9005 3.65783 18.8762 6.99985 17.298 12.6444Z",
    fill: "url(#paint4_linear_18688_63939)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M36.8686 15.0578C36.3304 16.3725 35.4798 17.5894 34.3277 18.5981C30.0733 22.3231 23.3317 21.8158 19.7486 17.4953C19.4227 17.1022 19.1347 16.6914 18.8833 16.2689C18.6148 15.817 17.8923 16.0371 17.9387 16.5549C18.1669 19.1065 19.474 21.6087 21.9331 23.4011C24.8572 25.5326 28.8126 25.908 32.1224 24.3745C36.0778 22.542 38.0549 18.8511 37.8486 15.2109C37.8194 14.6906 37.0688 14.573 36.8699 15.059L36.8686 15.0578Z",
    fill: "url(#paint5_linear_18688_63939)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M0.522301 30.5706L4.06641 30.5664L4.02784 0.124982L0.483738 0.129157L0.522301 30.5706Z",
    fill: "url(#paint6_linear_18688_63939)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3764 19.8832L29.8516 20.3358L29.9304 19.8634L30.3764 19.8832L30.5926 20.0143L30.5665 19.4766L30.3764 19.8832Z",
    fill: "url(#paint7_linear_18688_63939)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5926 20.0139L29.8516 20.3353L30.3764 19.8828L30.5926 20.0139Z",
    fill: "url(#paint8_linear_18688_63939)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5658 19.4766L29.9297 19.8634L30.3756 19.8832L30.5658 19.4766Z",
    fill: "url(#paint9_linear_18688_63939)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2679 21.752L27.0859 21.9044L27.2434 22.4405L27.2679 21.752Z",
    fill: "url(#paint10_linear_18688_63939)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2667 21.752L27.4782 21.9192L27.2422 22.4405",
    fill: "url(#paint11_linear_18688_63939)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.043 20.0293L26.999 22.4001L26.8466 21.6622L24.043 20.0293Z",
    fill: "url(#paint12_linear_18688_63939)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.999 22.4021L24.8497 21.5953L24.043 20.0312L25.1938 21.4329L26.999 22.4021Z",
    fill: "url(#paint13_linear_18688_63939)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8466 21.6642L26.6105 21.2952L24.043 20.0312L25.1938 21.4329L24.8497 21.5953L24.043 20.0312L25.1938 21.4329L26.999 22.4021L26.8466 21.6642Z",
    fill: "url(#paint14_linear_18688_63939)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.999 22.4001L24.043 20.0293L26.8466 21.6622L26.999 22.4001Z",
    fill: "url(#paint15_linear_18688_63939)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.043 20.0293L25.1938 21.431L24.8497 21.5934L24.043 20.0293Z",
    fill: "url(#paint16_linear_18688_63939)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6445 19.7061L28.6936 19.5832L29.2347 19.416L29.6084 19.4996L29.4315 20.0801L28.8463 20.0012L28.6445 19.7061Z",
    fill: "url(#paint17_linear_18688_63939)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2322 19.416L28.8438 20.0012L29.6059 19.4996",
    fill: "url(#paint18_linear_18688_63939)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4306 20.079L28.2305 20.8364L28.6437 19.7051L28.8455 20.0002L28.2305 20.8364L28.8455 20.0002L29.4306 20.079Z",
    fill: "url(#paint19_linear_18688_63939)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8455 20.002L28.2305 20.8382L29.4306 20.0808L28.8455 20.002Z",
    fill: "url(#paint20_linear_18688_63939)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0132 21.5762L31.2891 22.4691V22.0648L32.0132 21.5762Z",
    fill: "url(#paint21_linear_18688_63939)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2898 22.4679L28.9648 22.6111L31.2898 22.0637L30.8602 21.4824L32.0139 21.575L31.2898 22.0637V22.4679Z",
    fill: "url(#paint22_linear_18688_63939)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9648 22.6111L30.8602 21.4824L31.2898 22.0637L28.9648 22.6111Z",
    fill: "url(#paint23_linear_18688_63939)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2541 15.6562L26.2148 16.0497L26.3625 16.2907L26.52 15.9466L26.2541 15.6562Z",
    fill: "url(#paint24_linear_18688_63939)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2539 15.6562L26.323 16.0202L26.5197 15.9466",
    fill: "url(#paint25_linear_18688_63939)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2148 16.0492L26.3236 16.0195L26.363 16.291",
    fill: "url(#paint26_linear_18688_63939)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8984 18.4157L25.9641 17.5547L26.3797 18.2024L26.0994 18.1739L25.8984 18.4157Z",
    fill: "url(#paint27_linear_18688_63939)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9641 17.5547L26.0994 18.1739L26.3578 18.8859L26.3797 18.2024L26.3578 18.8859L25.8984 18.4157L26.0994 18.1739L26.3797 18.2024",
    fill: "url(#paint28_linear_18688_63939)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3819 18.2023L26.1016 18.1738L26.36 18.8859",
    fill: "url(#paint29_linear_18688_63939)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9474 13.2207L26.7422 13.8526L26.9152 14.2611L27.268 13.8304L26.9474 13.2207Z",
    fill: "url(#paint30_linear_18688_63939)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9453 13.2207L27.0342 13.6593L27.266 13.8304L26.9453 13.2207Z",
    fill: "url(#paint31_linear_18688_63939)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7422 13.8535L27.0362 13.6602L26.9152 14.262L26.7422 13.8535Z",
    fill: "url(#paint32_linear_18688_63939)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.839 18.2441L28.8047 18.6967L28.9373 18.8686L29.0505 18.5835L28.839 18.2441Z",
    fill: "url(#paint33_linear_18688_63939)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0505 18.5835L28.839 18.2441L28.9178 18.6376L29.0505 18.5835L28.9178 18.6376L28.8047 18.6967L28.9178 18.6376L28.9373 18.8686L28.8047 18.6967L28.839 18.2441",
    fill: "url(#paint34_linear_18688_63939)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9375 18.87L29.051 18.584L28.918 18.6382L28.9375 18.87Z",
    fill: "url(#paint35_linear_18688_63939)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8047 18.696L28.9182 18.6367L28.9378 18.8685",
    fill: "url(#paint36_linear_18688_63939)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8398 18.2441L28.9187 18.6376L29.0513 18.5835",
    fill: "url(#paint37_linear_18688_63939)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9276 16.4316L28.283 17.5277L28.1185 17.7072L28.0156 16.6439L28.2466 16.7558L28.9276 16.4316Z",
    fill: "url(#paint38_linear_18688_63939)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2466 16.7562L28.2013 16.2298L28.0156 16.6444L28.2466 16.7562L28.9276 16.4321L28.517 15.8672",
    fill: "url(#paint39_linear_18688_63939)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9263 16.4321L28.2817 17.5281L28.1172 17.7077L28.2454 16.7562L28.5157 15.8672L28.2 16.2298L28.2454 16.7562",
    fill: "url(#paint40_linear_18688_63939)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2817 17.5278L28.2454 16.7559L28.1172 17.7074L28.2817 17.5278Z",
    fill: "url(#paint41_linear_18688_63939)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9609 15.6816L30.2458 16.0163L30.3119 16.0688L30.2766 15.7135L30.2075 15.7602L29.9609 15.6816Z",
    fill: "url(#paint42_linear_18688_63939)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2075 15.7587L30.1883 15.5831L30.2766 15.7121L30.2075 15.7587L29.9609 15.6802L30.0601 15.4766",
    fill: "url(#paint43_linear_18688_63939)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9609 15.6802L30.2458 16.0148L30.3119 16.0673L30.2075 15.7587L30.0601 15.4766L30.1883 15.5831L30.2075 15.7587",
    fill: "url(#paint44_linear_18688_63939)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2454 16.0167L30.207 15.7598L30.3118 16.0693L30.2454 16.0167Z",
    fill: "url(#paint45_linear_18688_63939)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9143 16.4824L23.5664 16.7612L23.8074 16.6868L23.9143 16.4824Z",
    fill: "url(#paint46_linear_18688_63939)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8078 16.6851L23.8851 16.7922L24.1113 17.1068L24.0153 17.62L23.8975 17.9175L23.8152 17.6087L23.4141 17.2584L23.5668 16.7595L23.9146 16.4805L23.8078 16.6851Z",
    fill: "url(#paint47_linear_18688_63939)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8152 17.6084L23.4141 17.2582L23.6461 17.6896L23.8972 17.9172L23.8152 17.6084L24.1113 17.1065L23.9143 16.4805L23.8152 17.6084Z",
    fill: "url(#paint48_linear_18688_63939)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8972 17.9188L23.6461 17.6912L23.4141 17.2598L23.8152 17.61L23.8972 17.9188Z",
    fill: "url(#paint49_linear_18688_63939)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1126 17.1074L23.8164 17.6093L23.8984 17.9181L24.0163 17.6209L24.1126 17.1074Z",
    fill: "url(#paint50_linear_18688_63939)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5664 16.7595L23.8074 16.6851L23.9143 16.4805L23.5664 16.7595Z",
    fill: "url(#paint51_linear_18688_63939)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9154 16.4805L23.8086 16.6851L23.8877 16.7961L23.8162 17.6084L24.1124 17.1065L23.9154 16.4805Z",
    fill: "url(#paint52_linear_18688_63939)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8877 16.7961L23.9154 16.4805L23.8086 16.6851",
    fill: "url(#paint53_linear_18688_63939)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3602 19.5306L23.3359 19.2527L23.4831 19.0918L23.3602 19.5306Z",
    fill: "url(#paint54_linear_18688_63939)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 19.1456L23.2574 18.8945L23.4871 19.0931L23.2574 18.8945L23.3399 19.254L23.125 19.1456L23.3642 19.5319L23.3399 19.254L23.4871 19.0931L23.3399 19.254L23.2574 18.8945L23.3399 19.254L23.4871 19.0931L23.2574 18.8945L23.125 19.1456Z",
    fill: "url(#paint55_linear_18688_63939)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3399 19.254L23.2574 18.8945L23.125 19.1456L23.3399 19.254L23.4871 19.0931L23.3399 19.254Z",
    fill: "url(#paint56_linear_18688_63939)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6445 14.2344L28.6693 14.4999L28.9003 14.6081L29.0823 14.6278L28.8906 14.3378L28.6445 14.2344Z",
    fill: "url(#paint57_linear_18688_63939)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8162 14.3892L28.9792 14.2246L28.8162 14.3892L28.6445 14.2344L28.9792 14.2246L29.0823 14.6278",
    fill: "url(#paint58_linear_18688_63939)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8162 14.3892L28.9792 14.2246L28.6445 14.2344L28.8162 14.3892L28.6693 14.4999L28.9003 14.6081",
    fill: "url(#paint59_linear_18688_63939)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1938 14.5391L24.9132 14.8637L24.8984 15.1047L25.169 14.8489L25.0314 14.8637L24.8984 15.1047L25.0314 14.8637H24.9132H25.0314L25.1938 14.5391Z",
    fill: "url(#paint60_linear_18688_63939)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1699 14.8477L25.0318 14.8625L24.8984 15.1043L25.1699 14.8477Z",
    fill: "url(#paint61_linear_18688_63939)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M25.169 14.8489L25.1938 14.5391L25.0314 14.8637H24.9132L24.8984 15.1047L25.0314 14.8637L25.169 14.8489Z",
    fill: "url(#paint62_linear_18688_63939)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1944 14.5391L24.9141 14.8638H25.0322C25.0322 14.8638 25.1944 14.5331 25.1944 14.5391Z",
    fill: "url(#paint63_linear_18688_63939)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5379 21.636L23.8224 21.4512L23.7383 21.4562L24.5379 21.636Z",
    fill: "url(#paint64_linear_18688_63939)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M23.676 20.9913L23.7271 20.6016L23.5781 20.9718L23.676 20.9913L23.8207 21.4492L23.7366 21.4542L23.5781 20.9718",
    fill: "url(#paint65_linear_18688_63939)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8207 21.4492L23.7271 20.6016L23.676 20.9913L23.5781 20.9718L23.7366 21.4542L24.5362 21.634L24.3735 21.4167L23.9787 20.7535L23.7271 20.6016L24.3735 21.4167L23.8207 21.4492L24.5362 21.634L23.8207 21.4492Z",
    fill: "url(#paint66_linear_18688_63939)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8207 21.45L23.676 20.9922L23.5781 20.9727L23.7366 21.455L23.8207 21.45Z",
    fill: "url(#paint67_linear_18688_63939)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6758 20.9913L23.8206 21.4492L24.3733 21.4167L23.7269 20.6016L23.6758 20.9913Z",
    fill: "url(#paint68_linear_18688_63939)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M23.676 20.9922L23.8207 21.45L23.7366 21.455L23.5781 20.9727L23.676 20.9922Z",
    fill: "url(#paint69_linear_18688_63939)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3722 21.416L24.3359 21.5822L24.5354 21.634",
    fill: "url(#paint70_linear_18688_63939)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7103 20.4234L27.2366 19.6758L26.3906 20.3939L26.7103 20.4234L27.8121 20.4334L28.0776 20.3301L27.2366 19.6758L26.3906 20.3939L26.7103 20.4234L27.2662 21.6974L26.3906 20.3939L27.2366 19.6758L26.7103 20.4234Z",
    fill: "url(#paint71_linear_18688_63939)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2669 21.6974L26.7109 20.4234L27.8127 20.4334L26.7109 20.4234L27.2373 19.6758L27.8127 20.4334L27.2669 21.6974L28.0783 20.3301L27.2669 21.6974Z",
    fill: "url(#paint72_linear_18688_63939)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2669 21.6959L26.7109 20.4219L27.8127 20.4319L27.2669 21.6959Z",
    fill: "url(#paint73_linear_18688_63939)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2383 19.6758L27.8137 20.4334L28.0793 20.3301L27.2383 19.6758Z",
    fill: "url(#paint74_linear_18688_63939)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7103 20.4234L27.2366 19.6758L26.3906 20.3939L27.2366 19.6758L26.3906 20.3939L26.7103 20.4234L27.2366 19.6758L27.8121 20.4334L28.0776 20.3301L27.2662 21.6974L27.8121 20.4334L26.7103 20.4234Z",
    fill: "url(#paint75_linear_18688_63939)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3906 20.3945L26.7103 20.4241L27.2662 21.6981L26.3906 20.3945Z",
    fill: "url(#paint76_linear_18688_63939)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2366 19.6758L26.7103 20.4234L26.3906 20.3939L27.2366 19.6758Z",
    fill: "url(#paint77_linear_18688_63939)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8389 20.004L25.1016 19.625L25.287 20.2595L25.8389 20.004Z",
    fill: "url(#paint78_linear_18688_63939)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8359 19.373L25.116 20.2507L25.285 20.2589L25.0997 19.6244L24.8359 19.373Z",
    fill: "url(#paint79_linear_18688_63939)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0997 19.6244L25.837 20.0033L25.8948 19.8963L24.8359 19.373L25.0997 19.6244Z",
    fill: "url(#paint80_linear_18688_63939)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2852 20.2594L26.171 20.8117L25.8371 20.0039L25.2852 20.2594Z",
    fill: "url(#paint81_linear_18688_63939)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M26.382 21.0131L25.8959 19.8965L26.382 21.0131L25.1172 20.2509L25.2862 20.2591L26.1721 20.8113L26.382 21.0131L26.1721 20.8113L26.382 21.0131Z",
    fill: "url(#paint82_linear_18688_63939)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8359 19.373L25.116 20.2507L25.285 20.2589L25.0997 19.6244L24.8359 19.373Z",
    fill: "url(#paint83_linear_18688_63939)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8976 19.8965L25.8398 20.0036L26.1737 20.8113L26.3836 21.0131L25.8976 19.8965Z",
    fill: "url(#paint84_linear_18688_63939)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7773 16.9258L30.7979 18.8496L31.42 18.1159L31.4271 18.1078L31.2288 17.8575L31.3351 17.6114L31.1663 17.2481L30.8591 17.0331L30.7773 16.9258Z",
    fill: "url(#paint85_linear_18688_63939)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8594 17.0332L31.2291 17.8576L31.1666 17.2481",
    fill: "url(#paint86_linear_18688_63939)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3341 17.6113L31.3802 17.7442L31.4261 18.1077L31.2278 17.8574L30.7969 18.8495L31.4261 18.1077L31.3341 17.6113Z",
    fill: "url(#paint87_linear_18688_63939)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2266 17.8574L31.3328 17.6113L31.4249 18.1077",
    fill: "url(#paint88_linear_18688_63939)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7773 16.9258L30.9896 17.8928L30.7979 18.8496L30.7773 16.9258Z",
    fill: "url(#paint89_linear_18688_63939)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9896 17.8928L30.785 17.8261L30.7773 16.9258L30.9896 17.8928Z",
    fill: "url(#paint90_linear_18688_63939)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M31.678 19.9648L30.793 21.2172L31.5374 21.034L31.5459 21.0318L31.5345 20.7776L31.7181 20.6682L31.7787 20.3546L31.6806 20.0724L31.678 19.9648Z",
    fill: "url(#paint91_linear_18688_63939)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6774 20.0723L31.5312 20.7775L31.7755 20.3544",
    fill: "url(#paint92_linear_18688_63939)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7181 20.668L31.6857 20.7753L31.5459 21.0316L31.5345 20.7774L30.793 21.217L31.5459 21.0316L31.7181 20.668Z",
    fill: "url(#paint93_linear_18688_63939)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5312 20.7774L31.7148 20.668L31.5426 21.0316",
    fill: "url(#paint94_linear_18688_63939)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M31.678 19.9648L31.3637 20.6888L30.793 21.2172L31.678 19.9648Z",
    fill: "url(#paint95_linear_18688_63939)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M31.363 20.6888L31.2617 20.5503L31.6773 19.9648L31.363 20.6888Z",
    fill: "url(#paint96_linear_18688_63939)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0142 22.8008L26.4238 23.0566L26.1484 23.7502L26.6239 23.3219L27.0142 22.8008Z",
    fill: "url(#paint97_linear_18688_63939)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6239 23.3219L27.0142 22.8008L26.4238 23.0566L26.6239 23.3219L26.1484 23.7504L26.8468 23.4553",
    fill: "url(#paint98_linear_18688_63939)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8478 23.4548L26.625 23.3214L27.0153 22.8008L26.8478 23.4548L26.625 23.3214L26.8478 23.4548Z",
    fill: "url(#paint99_linear_18688_63939)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7188 23.0586L28.8451 23.211L28.786 23.3735L27.758 23.216L27.7188 23.0586Z",
    fill: "url(#paint100_linear_18688_63939)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9103 22.9316L28.8415 23.212L27.7151 23.0595L27.2969 22.9514L28.9103 22.9316Z",
    fill: "url(#paint101_linear_18688_63939)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7544 23.2141L27.7151 23.0567L28.8415 23.2091L28.7824 23.3715L28.8415 23.2091L29.9383 22.9929L28.7824 23.3715L27.7544 23.2141L27.2969 22.9485L27.7151 23.0567L27.2969 22.9485L29.1463 22.6484L28.9103 22.9288L28.8415 23.2091L28.9103 22.9288L29.9383 22.9929L29.1463 22.6484L28.9103 22.9288L27.2969 22.9485",
    fill: "url(#paint102_linear_18688_63939)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9406 22.9938L28.9126 22.9297L28.8438 23.21L29.9406 22.9938Z",
    fill: "url(#paint103_linear_18688_63939)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9103 22.9288L29.1463 22.6484L27.2969 22.9485L28.9103 22.9288Z",
    fill: "url(#paint104_linear_18688_63939)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8239 23.0406L26.993 22.6764L24.8582 22.6717L24.686 21.8848L23.5156 22.1749L24.8582 22.6717L24.8239 23.0406L23.5156 22.1749L24.686 21.8848L26.2061 22.1896L26.993 22.6764L24.8239 23.0406L26.993 22.6764L24.8582 22.6717L24.686 21.8848L23.5156 22.1749L24.8239 23.0406L24.8582 22.6717L23.5156 22.1749",
    fill: "url(#paint105_linear_18688_63939)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9933 22.6766L24.8242 23.0408L24.8585 22.6719L26.9933 22.6766Z",
    fill: "url(#paint106_linear_18688_63939)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M24.686 21.8848L24.8582 22.6717L23.5156 22.1749L24.686 21.8848Z",
    fill: "url(#paint107_linear_18688_63939)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2076 22.1896L24.6875 21.8848L24.8597 22.6717",
    fill: "url(#paint108_linear_18688_63939)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5177 21.0789L30.2569 21.1908L30.0625 21.0977L30.9557 20.2754",
    fill: "url(#paint109_linear_18688_63939)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7734 22.2828L29.6369 20.753L30.9546 20.2754L30.5047 21.4046L30.5166 21.0789L30.9546 20.2754L30.0614 21.0977L29.6369 20.753L30.9546 20.2754L30.0614 21.0977L29.6369 20.753",
    fill: "url(#paint110_linear_18688_63939)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7734 22.2818L29.7824 21.959L29.549 21.9321L29.7824 21.959L30.5047 21.4036L30.2558 21.1897L29.549 21.9321L28.7734 22.2818L29.6369 20.752L30.0614 21.0966L28.7734 22.2818Z",
    fill: "url(#paint111_linear_18688_63939)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5186 21.0801L30.2578 21.1919L30.5068 21.4058L30.5186 21.0801Z",
    fill: "url(#paint112_linear_18688_63939)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M29.549 21.9331L30.2558 21.1908L30.0614 21.0977L28.7734 22.2828L29.549 21.9331Z",
    fill: "url(#paint113_linear_18688_63939)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9336 21.3739L28.9861 20.7051L28.8484 21.6102L27.9336 21.3739Z",
    fill: "url(#paint114_linear_18688_63939)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9318 21.3739L27.3906 22.525L28.3105 22.2642L28.8466 21.6102L29.0826 21.5904L28.9843 20.7051L27.9318 21.3739Z",
    fill: "url(#paint115_linear_18688_63939)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4777 22.3177L28.3105 22.2636L28.8466 21.6096L29.0826 21.5898L28.4777 22.3177L27.3906 22.5245L28.3105 22.2636L28.4777 22.3177Z",
    fill: "url(#paint116_linear_18688_63939)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8484 21.6102L27.9336 21.3739L28.9861 20.7051L28.8484 21.6102Z",
    fill: "url(#paint117_linear_18688_63939)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4777 22.3197L28.3105 22.2656L27.3906 22.5264L28.4777 22.3197Z",
    fill: "url(#paint118_linear_18688_63939)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9882 7.06143C28.5384 7.06731 30.098 7.57369 31.4056 8.61102C34.4945 11.0617 35.0068 15.5455 32.5496 18.6262C30.0924 21.707 25.5965 22.2179 22.5076 19.7673C21.2001 18.7299 20.3545 17.3284 20 15.8232C20.2143 17.8869 21.2279 19.8667 22.9848 21.2605C26.4518 24.0109 31.498 23.4377 34.2558 19.98C37.0136 16.5222 36.4389 11.4895 32.9719 8.73902C31.2151 7.34522 29.0531 6.80571 26.9884 7.06143H26.9882Z",
    fill: "url(#paint119_linear_18688_63939)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18688_63939",
    x1: 0.486472,
    y1: 31.0469,
    x2: 5.69606,
    y2: -5.18548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18688_63939",
    x1: 0.486472,
    y1: 30.5781,
    x2: 5.69606,
    y2: -5.65423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18688_63939",
    x1: 43.8811,
    y1: 15.3425,
    x2: 0.486506,
    y2: 15.3425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A533FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A234FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#983AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8844FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7252FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#5563FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#3179FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#0793FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18688_63939",
    x1: 40.0625,
    y1: 14.4438,
    x2: 16.0421,
    y2: 14.4438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18688_63939",
    x1: 37.7254,
    y1: 10.6213,
    x2: 18.4163,
    y2: 20.7135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#00CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#00B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#00A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0098FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0793FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3179FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5563FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7252FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#8844FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#983AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#A234FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#A533FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18688_63939",
    x1: 29.7439,
    y1: 26.7182,
    x2: 27.4253,
    y2: 12.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F4F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D5C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B8A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#8B67FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7A51FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6D40FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6434FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5F2DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_18688_63939",
    x1: 4.04584,
    y1: 14.331,
    x2: 0.501735,
    y2: 14.3355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_18688_63939",
    x1: 30.5926,
    y1: 19.4766,
    x2: 30.3494,
    y2: 20.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_18688_63939",
    x1: 30.5926,
    y1: 19.8828,
    x2: 30.5222,
    y2: 20.4228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_18688_63939",
    x1: 30.5658,
    y1: 19.4766,
    x2: 30.4996,
    y2: 19.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_18688_63939",
    x1: 27.2679,
    y1: 21.752,
    x2: 26.8594,
    y2: 22.2575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_18688_63939",
    x1: 27.4782,
    y1: 21.752,
    x2: 27.1032,
    y2: 22.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_18688_63939",
    x1: 26.999,
    y1: 20.0293,
    x2: 26.5203,
    y2: 22.8244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_18688_63939",
    x1: 26.999,
    y1: 20.0312,
    x2: 26.5203,
    y2: 22.8263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_18688_63939",
    x1: 26.999,
    y1: 20.0312,
    x2: 26.5203,
    y2: 22.8263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_18688_63939",
    x1: 26.999,
    y1: 20.0293,
    x2: 26.5203,
    y2: 22.8244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_18688_63939",
    x1: 25.1938,
    y1: 20.0293,
    x2: 24.6858,
    y2: 21.7799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_18688_63939",
    x1: 29.6084,
    y1: 19.416,
    x2: 29.4924,
    y2: 20.2048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_18688_63939",
    x1: 29.6059,
    y1: 19.416,
    x2: 29.4925,
    y2: 20.1076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_18688_63939",
    x1: 29.4306,
    y1: 19.7051,
    x2: 29.1651,
    y2: 21.0245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_18688_63939",
    x1: 29.4306,
    y1: 20.002,
    x2: 29.2829,
    y2: 20.9948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_18688_63939",
    x1: 32.0132,
    y1: 21.5762,
    x2: 31.7464,
    y2: 22.5895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_18688_63939",
    x1: 32.0139,
    y1: 21.4824,
    x2: 31.9064,
    y2: 22.8436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_18688_63939",
    x1: 31.2898,
    y1: 21.4824,
    x2: 31.1493,
    y2: 22.8376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_18688_63939",
    x1: 26.52,
    y1: 15.6562,
    x2: 26.2344,
    y2: 16.2994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_18688_63939",
    x1: 26.5197,
    y1: 15.6562,
    x2: 26.4008,
    y2: 16.0631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_18688_63939",
    x1: 26.363,
    y1: 16.0195,
    x2: 26.2512,
    y2: 16.3052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_18688_63939",
    x1: 26.3797,
    y1: 17.5547,
    x2: 26.0314,
    y2: 18.4665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_18688_63939",
    x1: 26.3797,
    y1: 17.5547,
    x2: 25.6723,
    y2: 18.7524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_18688_63939",
    x1: 26.3819,
    y1: 18.1738,
    x2: 26.0198,
    y2: 18.8415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_18688_63939",
    x1: 27.268,
    y1: 13.2207,
    x2: 26.8155,
    y2: 14.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_18688_63939",
    x1: 27.266,
    y1: 13.2207,
    x2: 27.0081,
    y2: 13.8559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_18688_63939",
    x1: 27.0362,
    y1: 13.6602,
    x2: 26.7683,
    y2: 14.2734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_18688_63939",
    x1: 29.0505,
    y1: 18.2441,
    x2: 28.7328,
    y2: 18.8296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_18688_63939",
    x1: 29.0505,
    y1: 18.2441,
    x2: 28.7328,
    y2: 18.8296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_18688_63939",
    x1: 29.051,
    y1: 18.584,
    x2: 28.9195,
    y2: 18.8707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_18688_63939",
    x1: 28.9378,
    y1: 18.6367,
    x2: 28.8459,
    y2: 18.8838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_18688_63939",
    x1: 29.0513,
    y1: 18.2441,
    x2: 28.8875,
    y2: 18.6565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_18688_63939",
    x1: 28.9276,
    y1: 16.4316,
    x2: 28.5031,
    y2: 17.8528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_18688_63939",
    x1: 28.9276,
    y1: 15.8672,
    x2: 28.7123,
    y2: 16.9012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_18688_63939",
    x1: 28.9263,
    y1: 15.8672,
    x2: 28.0485,
    y2: 17.6743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_18688_63939",
    x1: 28.2817,
    y1: 16.7559,
    x2: 27.717,
    y2: 17.2133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_18688_63939",
    x1: 30.3119,
    y1: 15.6816,
    x2: 30.2071,
    y2: 16.1267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_18688_63939",
    x1: 30.2766,
    y1: 15.4766,
    x2: 30.2135,
    y2: 15.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_18688_63939",
    x1: 30.3119,
    y1: 15.4766,
    x2: 30.0838,
    y2: 16.1114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_18688_63939",
    x1: 30.3118,
    y1: 15.7598,
    x2: 30.1423,
    y2: 16.0285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_18688_63939",
    x1: 23.9143,
    y1: 16.4824,
    x2: 23.858,
    y2: 16.8111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_18688_63939",
    x1: 24.1113,
    y1: 16.4805,
    x2: 23.4684,
    y2: 17.9414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_18688_63939",
    x1: 24.1113,
    y1: 16.4805,
    x2: 23.4686,
    y2: 17.9412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_18688_63939",
    x1: 23.8972,
    y1: 17.2598,
    x2: 23.6825,
    y2: 17.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_18688_63939",
    x1: 24.1126,
    y1: 17.1074,
    x2: 23.684,
    y2: 17.8407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_18688_63939",
    x1: 23.9143,
    y1: 16.4805,
    x2: 23.8579,
    y2: 16.8094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_18688_63939",
    x1: 24.1124,
    y1: 16.4805,
    x2: 23.4461,
    y2: 17.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_18688_63939",
    x1: 23.9154,
    y1: 16.4805,
    x2: 23.7425,
    y2: 16.7544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_18688_63939",
    x1: 23.4831,
    y1: 19.0918,
    x2: 23.2418,
    y2: 19.4707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_18688_63939",
    x1: 23.4871,
    y1: 18.8945,
    x2: 23.2323,
    y2: 19.5723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_18688_63939",
    x1: 23.4871,
    y1: 18.8945,
    x2: 23.3986,
    y2: 19.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_18688_63939",
    x1: 29.0823,
    y1: 14.2344,
    x2: 28.9939,
    y2: 14.6949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_18688_63939",
    x1: 29.0823,
    y1: 14.2246,
    x2: 28.9896,
    y2: 14.6957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_18688_63939",
    x1: 28.9792,
    y1: 14.2246,
    x2: 28.8718,
    y2: 14.6637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_18688_63939",
    x1: 25.1938,
    y1: 14.5391,
    x2: 24.9533,
    y2: 15.1272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_18688_63939",
    x1: 25.1699,
    y1: 14.8477,
    x2: 25.1095,
    y2: 15.1469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_18688_63939",
    x1: 25.1938,
    y1: 14.5391,
    x2: 24.9533,
    y2: 15.1272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_18688_63939",
    x1: 25.1944,
    y1: 14.5391,
    x2: 25.1026,
    y2: 14.9104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_18688_63939",
    x1: 24.5379,
    y1: 21.4512,
    x2: 24.5268,
    y2: 21.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_18688_63939",
    x1: 23.8207,
    y1: 20.6016,
    x2: 23.324,
    y2: 21.2635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_18688_63939",
    x1: 24.5362,
    y1: 20.6016,
    x2: 24.2624,
    y2: 21.7915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_18688_63939",
    x1: 23.8207,
    y1: 20.9727,
    x2: 23.6102,
    y2: 21.4686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_18688_63939",
    x1: 24.3733,
    y1: 20.6016,
    x2: 24.1233,
    y2: 21.5653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_18688_63939",
    x1: 23.8207,
    y1: 20.9727,
    x2: 23.6102,
    y2: 21.4686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_18688_63939",
    x1: 24.5354,
    y1: 21.416,
    x2: 24.4769,
    y2: 21.6669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_18688_63939",
    x1: 28.0776,
    y1: 19.6758,
    x2: 27.4884,
    y2: 21.9784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_18688_63939",
    x1: 28.0783,
    y1: 19.6758,
    x2: 27.374,
    y2: 21.9068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_18688_63939",
    x1: 27.8127,
    y1: 20.4219,
    x2: 27.453,
    y2: 21.8791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_18688_63939",
    x1: 28.0793,
    y1: 19.6758,
    x2: 27.9087,
    y2: 20.5624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_18688_63939",
    x1: 28.0776,
    y1: 19.6758,
    x2: 27.4884,
    y2: 21.9784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_18688_63939",
    x1: 27.2662,
    y1: 20.3945,
    x2: 26.8094,
    y2: 21.8312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_18688_63939",
    x1: 27.2366,
    y1: 19.6758,
    x2: 27.0713,
    y2: 20.5519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_18688_63939",
    x1: 25.8389,
    y1: 19.625,
    x2: 25.7021,
    y2: 20.3698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_18688_63939",
    x1: 25.285,
    y1: 19.373,
    x2: 24.9005,
    y2: 20.2861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_18688_63939",
    x1: 25.8948,
    y1: 19.373,
    x2: 25.7991,
    y2: 20.1258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_18688_63939",
    x1: 26.171,
    y1: 20.0039,
    x2: 25.9871,
    y2: 20.9483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_18688_63939",
    x1: 26.382,
    y1: 19.8965,
    x2: 26.1353,
    y2: 21.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_18688_63939",
    x1: 25.285,
    y1: 19.373,
    x2: 24.9005,
    y2: 20.2861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_18688_63939",
    x1: 26.3836,
    y1: 19.8965,
    x2: 25.8853,
    y2: 21.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_18688_63939",
    x1: 31.4271,
    y1: 16.9258,
    x2: 30.3727,
    y2: 18.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_18688_63939",
    x1: 31.2291,
    y1: 17.0332,
    x2: 30.8408,
    y2: 17.8488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_18688_63939",
    x1: 31.4261,
    y1: 17.6113,
    x2: 30.8895,
    y2: 18.8884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_18688_63939",
    x1: 31.4249,
    y1: 17.6113,
    x2: 31.1745,
    y2: 18.0798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_18688_63939",
    x1: 30.9896,
    y1: 16.9258,
    x2: 30.0374,
    y2: 17.4179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_18688_63939",
    x1: 30.9896,
    y1: 16.9258,
    x2: 30.4031,
    y2: 17.5288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_18688_63939",
    x1: 31.7787,
    y1: 19.9648,
    x2: 31.3947,
    y2: 21.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_18688_63939",
    x1: 31.7755,
    y1: 20.0723,
    x2: 31.3931,
    y2: 20.6923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_18688_63939",
    x1: 31.7181,
    y1: 20.668,
    x2: 31.635,
    y2: 21.3237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_18688_63939",
    x1: 31.7148,
    y1: 20.668,
    x2: 31.5564,
    y2: 21.0423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_18688_63939",
    x1: 31.678,
    y1: 19.9648,
    x2: 31.2572,
    y2: 21.3575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_18688_63939",
    x1: 31.6773,
    y1: 19.9648,
    x2: 31.3903,
    y2: 20.7366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_18688_63939",
    x1: 27.0142,
    y1: 22.8008,
    x2: 26.7585,
    y2: 23.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_18688_63939",
    x1: 27.0142,
    y1: 22.8008,
    x2: 26.7584,
    y2: 23.8933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_18688_63939",
    x1: 27.0153,
    y1: 22.8008,
    x2: 26.7636,
    y2: 23.5044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_18688_63939",
    x1: 28.8451,
    y1: 23.0586,
    x2: 28.8224,
    y2: 23.4393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_18688_63939",
    x1: 28.9103,
    y1: 22.9316,
    x2: 28.8977,
    y2: 23.2714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_18688_63939",
    x1: 29.9383,
    y1: 22.6484,
    x2: 29.8872,
    y2: 23.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_18688_63939",
    x1: 29.9406,
    y1: 22.9297,
    x2: 29.922,
    y2: 23.2689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_18688_63939",
    x1: 29.1463,
    y1: 22.6484,
    x2: 29.1337,
    y2: 23.0122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_18688_63939",
    x1: 26.993,
    y1: 21.8848,
    x2: 26.894,
    y2: 23.2804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_18688_63939",
    x1: 26.9933,
    y1: 22.6719,
    x2: 26.9771,
    y2: 23.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_18688_63939",
    x1: 24.8582,
    y1: 21.8848,
    x2: 24.7405,
    y2: 22.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_18688_63939",
    x1: 26.2076,
    y1: 21.8848,
    x2: 26.1033,
    y2: 22.8282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_18688_63939",
    x1: 30.9557,
    y1: 20.2754,
    x2: 30.7238,
    y2: 21.3354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_18688_63939",
    x1: 30.9546,
    y1: 20.2754,
    x2: 30.4937,
    y2: 22.6209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_18688_63939",
    x1: 30.5047,
    y1: 20.752,
    x2: 30.1665,
    y2: 22.5446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_18688_63939",
    x1: 30.5186,
    y1: 21.0801,
    x2: 30.4202,
    y2: 21.4491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_18688_63939",
    x1: 30.2558,
    y1: 21.0977,
    x2: 30.0172,
    y2: 22.4951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_18688_63939",
    x1: 28.9861,
    y1: 20.7051,
    x2: 28.791,
    y2: 21.7676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_18688_63939",
    x1: 29.0826,
    y1: 20.7051,
    x2: 28.6008,
    y2: 22.8029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_18688_63939",
    x1: 29.0826,
    y1: 21.5898,
    x2: 28.9507,
    y2: 22.7085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_18688_63939",
    x1: 28.9861,
    y1: 20.7051,
    x2: 28.791,
    y2: 21.7676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_18688_63939",
    x1: 28.4777,
    y1: 22.2656,
    x2: 28.4615,
    y2: 22.5813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_18688_63939",
    x1: 36,
    y1: 7,
    x2: 32.0349,
    y2: 25.5697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkArcana);
export default __webpack_public_path__ + "static/media/bulk-arcana.b5aeec7b6be1501347a52b6ffe6cbdc6.svg";
export { ForwardRef as ReactComponent };